import { Box, Flex, Heading, IconButton, Stack } from '@chakra-ui/core'
import React from 'react'
import { X } from 'react-feather'
import { usePreviewerContext } from '../../../context/PreviewerProvider'

const Previewer: React.FC<{ onClose?: () => void }> = ({ onClose }) => {
  const { previewComponent, setFormIsDirty } = usePreviewerContext()

  return (
    <Box w="100%">
      <Flex alignItems="center" justifyContent="space-between" px={6} py={2} w="100%">
        {previewComponent?.title && (
          <Stack align="center" direction="row">
            {previewComponent.icon && (
              <IconButton
                icon={previewComponent.icon}
                m={0}
                p={0}
                aria-label="Preview Icon"
                rounded="full"
              />
            )}
            <Heading as="h3" size="sm" w="100%">
              {previewComponent.title}
            </Heading>
          </Stack>
        )}
        <Stack align="center" direction="row" spacing={8}>
          {previewComponent?.action && <Box>{previewComponent.action}</Box>}
          {onClose && (
            <IconButton
              icon={X}
              variant="ghost"
              aria-label="Close preview"
              size="sm"
              color="gray.500"
              onClick={() => {
                onClose()
                setFormIsDirty?.(false)
              }}
            />
          )}
        </Stack>
      </Flex>
      {previewComponent?.content && (
        <Box overflowY="auto" overflowX="hidden" p={6} pb={20} height="97vh">
          {previewComponent.content}
        </Box>
      )}
    </Box>
  )
}

export default Previewer
